
import { Flame } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StreakTrackerProps {
  currentStreak: number;
  /** Days of the week, 0=Sunday, 6=Saturday */
  activeDays: number[]; 
}

const dayLabels = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export function StreakTracker({ currentStreak, activeDays }: StreakTrackerProps) {
  const todayIndex = new Date().getDay();

  return (
    <div className="flex items-center gap-4 p-2 rounded-lg bg-slate-100 dark:bg-slate-800">
      <div className="flex items-center gap-2">
        <Flame className="text-orange-500 h-6 w-6" />
        <span className="text-sm font-bold text-slate-800 dark:text-white">
          {currentStreak}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        {dayLabels.map((day, index) => {
          const isActive = activeDays.includes(index);
          const isToday = index === todayIndex;

          return (
            <div
              key={index}
              className={cn(
                'w-6 h-6 rounded-full flex items-center justify-center transition-colors',
                {
                  'bg-orange-400 dark:bg-orange-500': isActive && !isToday,
                  'bg-slate-200 dark:bg-slate-700': !isActive && !isToday,
                  'border-2 border-orange-500 bg-transparent': isToday,
                }
              )}
            >
              <span
                className={cn(
                  'text-xs font-semibold',
                  {
                    'text-white dark:text-slate-900': isActive && !isToday,
                    'text-slate-500 dark:text-slate-400': !isActive && !isToday,
                    'text-orange-500 dark:text-orange-400': isToday,
                  }
                )}
              >
                {day}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
